import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestAppointmentMutationVariables = Types.Exact<{
  input: Types.RequestAppointmentInput;
  cloudflareTurnstileToken: Types.Scalars['String']['input'];
}>;


export type RequestAppointmentMutation = { __typename?: 'Mutation', requestAppointment: { __typename?: 'RequestAppointmentResponse', success: boolean, message?: string | null } };


export const RequestAppointmentDocument = gql`
    mutation RequestAppointment($input: RequestAppointmentInput!, $cloudflareTurnstileToken: String!) {
  requestAppointment(
    input: $input
    cloudflareTurnstileToken: $cloudflareTurnstileToken
  ) {
    success
    message
  }
}
    `;
export type RequestAppointmentMutationFn = Apollo.MutationFunction<RequestAppointmentMutation, RequestAppointmentMutationVariables>;

/**
 * __useRequestAppointmentMutation__
 *
 * To run a mutation, you first call `useRequestAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAppointmentMutation, { data, loading, error }] = useRequestAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      cloudflareTurnstileToken: // value for 'cloudflareTurnstileToken'
 *   },
 * });
 */
export function useRequestAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RequestAppointmentMutation, RequestAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAppointmentMutation, RequestAppointmentMutationVariables>(RequestAppointmentDocument, options);
      }
export type RequestAppointmentMutationHookResult = ReturnType<typeof useRequestAppointmentMutation>;
export type RequestAppointmentMutationResult = Apollo.MutationResult<RequestAppointmentMutation>;
export type RequestAppointmentMutationOptions = Apollo.BaseMutationOptions<RequestAppointmentMutation, RequestAppointmentMutationVariables>;